export default __webpack_public_path__ + "static/media/misc-books1-480w.1fc7856b.avif";